// Auto-generated file - Do not edit manually
export const APP_VERSION = {
  frontend: '2.18.1-RS1',
  buildDate: '2026-11-05',
  environment: 'production'
};
